module.exports = __webpack_public_path__ + "static/media/7.55feef4d.jpg";